export interface PurchaseContractLineForCreate {
  id: string;
  contractNo: number;
  description: string;
  supplierKey: string;
  supplierName: string;
  productKey: string;
  productDescription: string;
  unitOfMeasure: string;
  contractLineBalance: number;
  price: number;
  contractLineBalanceValue: number;
  orderQuantity: number;
  selected: boolean;
}
